<template>
 <div>
   <h1>Hello</h1>
    <div id="myChart" :style="{width: '100%', height: '770px'}"></div>
 </div>
</template>


<script>

export default {
  
  name: 'spacies',
  data () {
    return {
      msg: 'category'
    }
  },
  mounted(){
    this.drawLine();
  },
  methods: {

    drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        // 绘制图表
      var  option = {
         title: {
            text: '氨基酸位点分布'
        },
    xAxis: {
        type: 'category',
        data: ['W', 'F', 'M', 'N', 'R', 'K', 'Y', 'L', 'C', 'D', 'H', 'E', 'V', 'A', 'Q', 'G', 'T', 'I', 'S', 'P']
    },
    yAxis: {
        type: 'value'
    },
    series: [{
    //       data: [285, 918, 218, 7328, 566, 835, 1445, 1005, 171, 24756, 790, 12633, 1476, 1010, 1916, 3132, 2100, 986, 1729, 452],
    //     type: 'line',
    //      label: 1,
    // },
        data: [0.34, 0.94, 1.02, 4.63, 1.4, 1.58, 1.75, 1.79, 16.41, 20.59, 18.86, 12.99, 1.79, 1.87, 1.91, 3.01, 3.38, 1.41, 3.53, 0.8],
        type: 'line',
         label: 1,
    },
     {data: [0.23, 0.65, 1.17, 4.27, 0.9, 1.11, 1.51, 1.08, 17.23, 22.65, 21.35, 13.81, 1.53, 1.19, 1.62, 2.16, 3.01, 1.26, 2.89, 0.37],
        type: 'line'
    },
     {data: [0.24, 0.69, 1.21, 4.49, 0.91, 1.16, 1.57, 1.15, 17.71, 20.5, 22.34, 12.64, 1.6, 1.54, 1.66, 2.73, 3.1, 1.32, 3.02, 0.39]
,
        type: 'line'
    },
    // {data: [0.24, 0.69, 1.21, 4.49, 0.91, 1.16, 1.57, 1.15, 17.71,  22.34, 20.5,12.64, 1.6, 1.54, 1.66, 2.73, 3.1, 1.32, 3.02, 0.39],
    
    //     type: 'line'
    // }
    ]
};
     
    //option结束
     myChart.setOption(option);
  },

  //methods
}
}
</script>